import { mergeStyles } from '@uifabric/merge-styles'
import React from 'react'

export interface ButtonStyle {
    size: number
    padding: number
    separation: number
}

export const Button = ({name, action, styling} : {name: string, action: Function, styling?: ButtonStyle}) => {
    const style = mergeStyles({
        color: 'rgb(60, 83, 86)',
        outline: 'none',
        boxShadow: '0x 0x 4px 4px #0002',
        borderRadius: 8,
        background: '#fff',
        border: '1px solid rgba(60, 83, 86, 0.2)',
        padding: 4,
        paddingLeft: styling?.padding || 24,
        paddingRight: styling?.padding || 24,
        fontSize: styling?.size || 18,
        marginLeft: styling?.separation || 32,
        transition: 'background 0.1s',
        'selectors': {
            ':first-child': {
                marginLeft: 0,
            },
            ':hover': {
                background: '#eee',
            }
        }
    })
    
    return (
        <button className={style} onClick={() => action()}>{name}</button>
    )
}